<div *ngIf="!isLoading; else loading">
  <div class="status" [ngClass]="{'not-updated': !updateMessageWSResponse.isUpToDate}">{{ updateMessageWSResponse.updateLabel }}</div>
  <div class="status" [ngClass]="{'not-updated': !updateMessageWSResponse.isUpToDate}" *ngIf="!updateMessageWSResponse.isUpToDate">Données non remises à jour</div>
  <div class="details">{{ updateMessageWSResponse.tooltip }}</div>
</div>

<ng-template #loading>
  {{ loadingMessage }}
</ng-template>
